// /**
//  * src/hooks/useSettings.js
//  */
// import { useDispatch, useSelector } from "react-redux";
// import {
//   fetchUsers,
//   fetchArchivedUsers,
//   fetchUserById,
//   inviteUser,
//   toggleUser,
//   restoreUser,
//   deleteUser,
//   clearInviteState,
//   clearSelectedUser,
//   clearSettingsErrors,
// } from "../store/slices/settingsSlice";

// const useSettings = () => {
//   const dispatch = useDispatch();

//   const {
//     resources,
//     resPagination,
//     isLoadingResources,
//     resourcesError,
//     archived,
//     archPagination,
//     isLoadingArchived,
//     archivedError,
//     selectedUser,
//     isLoadingUser,
//     userError,
//     isInviting,
//     inviteError,
//     inviteSuccess,
//     isToggling,
//     toggleError,
//     isRestoring,
//     restoreError,
//     isDeleting,
//     deleteError,
//   } = useSelector((state) => state.settings);

//   return {
//     // ── State ──────────────────────────────
//     resources,
//     resPagination,
//     archived,
//     archPagination,
//     selectedUser,
//     inviteSuccess,

//     // ── Loading ────────────────────────────
//     isLoadingResources,
//     isLoadingArchived,
//     isLoadingUser,
//     isInviting,
//     isToggling,
//     isRestoring,
//     isDeleting,

//     // ── Errors ─────────────────────────────
//     resourcesError,
//     archivedError,
//     userError,
//     inviteError,
//     toggleError,
//     restoreError,
//     deleteError,

//     // ── Actions ────────────────────────────
//     loadUsers: (page, search) =>
//       dispatch(fetchUsers({ page, search })),
//     loadArchivedUsers: (page, search) =>
//       dispatch(fetchArchivedUsers({ page, search })),
//     loadUser: (userId) =>
//       dispatch(fetchUserById(userId)),
//     sendInvite: (userData) =>
//       dispatch(inviteUser(userData)),
//     toggleUserStatus: (userId) =>
//       dispatch(toggleUser(userId)),
//     restoreArchivedUser: (userId) =>
//       dispatch(restoreUser(userId)),
//     permanentlyDeleteUser: (userId) =>
//       dispatch(deleteUser(userId)),
//     clearInvite: () => dispatch(clearInviteState()),
//     clearUser: () => dispatch(clearSelectedUser()),
//     clearErrors: () => dispatch(clearSettingsErrors()),
//   };
// };

// export default useSettings;

import { useDispatch, useSelector } from "react-redux";
import {
  fetchUsers,
  fetchArchivedUsers,
  fetchUserById,
  inviteUser,
  toggleUser,
  restoreUser,
  deleteUser,
  updateUserRole as updateUserRoleThunk,   // ← ADDED
  clearInviteState,
  clearSelectedUser,
  clearSettingsErrors,
  fetchProjectsWithAccess,
} from "../store/slices/settingsSlice";

const useSettings = () => {
  const dispatch = useDispatch();

  const {
  resources,
  resPagination,
  isLoadingResources,
  resourcesError,
  archived,
  archPagination,
  isLoadingArchived,
  archivedError,
  selectedUser,
  isLoadingUser,
  userError,
  isInviting,
  inviteError,
  inviteSuccess,
  isToggling,
  toggleError,
  isRestoring,
  restoreError,
  isDeleting,
  deleteError,
  projects,           
  isLoadingProjects, 
  projectsError,      
  isUpdatingRole,     
  updateRoleError,    
} = useSelector((state) => state.settings);

  const loadProjectsWithAccess = () => {
    dispatch(fetchProjectsWithAccess());
  };

  return {
    // ── State ──────────────────────────────
    resources,
    resPagination,
    archived,
    archPagination,
    selectedUser,
    inviteSuccess,
    projects,

    // ── Loading ────────────────────────────
    isLoadingResources,
    isLoadingProjects,
    isLoadingArchived,
    isLoadingUser,
    isInviting,
    isToggling,
    isRestoring,
    isDeleting,
    isUpdatingRole,    // ← ADDED

    // ── Errors ─────────────────────────────
    resourcesError,
    projectsError,
    archivedError,
    userError,
    inviteError,
    toggleError,
    restoreError,
    deleteError,
    updateRoleError,   // ← ADDED

    // ── Actions ────────────────────────────
    loadUsers: (page, search) => dispatch(fetchUsers({ page, search })),
    loadArchivedUsers: (page, search) =>
      dispatch(fetchArchivedUsers({ page, search })),
    loadUser: (userId) =>
      dispatch(fetchUserById(userId)),
    sendInvite: (userData) =>
      dispatch(inviteUser(userData)),
    toggleUserStatus: (userId) =>
      dispatch(toggleUser(userId)),
    restoreArchivedUser: (userId) =>
      dispatch(restoreUser(userId)),
    permanentlyDeleteUser: (userId) =>
      dispatch(deleteUser(userId)),
    updateUserRole: (userId, userData) =>
      dispatch(updateUserRoleThunk({ userId, ...userData })),
    clearInvite: () => dispatch(clearInviteState()),
    clearUser: () => dispatch(clearSelectedUser()),
    clearErrors: () => dispatch(clearSettingsErrors()),
    loadProjectsWithAccess,
  };
};

export default useSettings;
